module.exports = __webpack_public_path__ + "public/img/ico-tabbar-inactive-history.031141b9.svg";